export default "__VITE_ASSET__DXfTdTF9__"